import React, { useEffect, useState } from 'react';
import { Grid, Box, Button, Card, CardContent, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useSnackbar } from 'notistack';
import PositionData from './PositionData';
import { styles } from './styles';
import { usePositionDetailsMutation, usePositionDetailsWithCompaFieldsMutation } from '../../../api/positions';
import { hasPermission } from '../../../utils/permission';
import PositionMenu from '../Positions/PositionMenu';
import ActionButton from '../../../components/common/ActionButtonAndMenu/ActionButton';

const ViewPosition = (props) => {
    const navigate = useNavigate();
    const params = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const [positionDetails, setPositionDetails] = useState({
        isLoading: true,
    });

    const authorities = useSelector((state) => state.session.user.authorities);

    const userHasCompaDisplayPermisson = hasPermission(authorities, [
        'ROLE_BASE_PERMISSION_RECRUIT_INDEX_COMPA_VIEW_POSITION',
    ]);

    const [positionDetailsMutation, { isLoading: isPositionDetailsLoading }] = usePositionDetailsMutation();
    const [positionDetailsWithCompaFieldsMutation, { isLoading: isPositionDetailsWithCompaLoading }] =
        usePositionDetailsWithCompaFieldsMutation();

    const fetchData = async () => {
        const bodyFormData = new FormData();
        bodyFormData.append('id', params.id);
        try {
            const response = userHasCompaDisplayPermisson
                ? await positionDetailsWithCompaFieldsMutation(bodyFormData).unwrap()
                : await positionDetailsMutation(bodyFormData).unwrap();

            if (!response) return;
            if (response.status === 'ERROR') throw new Error(response?.message);

            if (response?.positionInstance) setPositionDetails(response);
        } catch (error) {
            if (error?.statusCode === 400) enqueueSnackbar(error?.data?.message, { variant: 'error' });
            else
                enqueueSnackbar(error?.message || 'Something went wrong! Position could not be fetched.', {
                    variant: 'error',
                });
        }
    };

    useEffect(() => {
        fetchData();
    }, [params.id, userHasCompaDisplayPermisson, positionDetailsMutation, positionDetailsWithCompaFieldsMutation]);

    return (
        <Box>
            <Box sx={styles.contentHeaderWrapper}>
                <Typography variant="h4">Position</Typography>
            </Box>
            <Box sx={styles.contentBodyWrapper}>
                <Card {...props}>
                    <CardContent>
                        <Grid container direction="column" spacing={2}>
                            <Grid item display={'flex'} justifyContent={'space-between'}>
                                <Button
                                    startIcon={<ChevronLeftIcon />}
                                    variant="text"
                                    color="secondary"
                                    onClick={() => navigate('/positions')}
                                >
                                    Back
                                </Button>
                                <PositionMenu
                                    Component={ActionButton}
                                    row={{ ...positionDetails.positionInstance, id: params.id } || {}}
                                    handleAction={fetchData}
                                />
                            </Grid>
                        </Grid>
                        <Grid item>
                            <PositionData
                                position={positionDetails}
                                isLoading={isPositionDetailsLoading || isPositionDetailsWithCompaLoading}
                            />
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};

export default ViewPosition;
